export enum EFeatureFlag {
	TEST_MULTIVARIATE = 'TEST_MULTIVARIATE',
}
